import React from 'react';
import { MdGroups } from 'react-icons/md';

function SharedClassBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-xs font-semibold text-indigo-700"
      title="This tutor teaches multiple batches together"
    >
      <MdGroups aria-hidden="true" />
      Shared class
    </span>
  );
}

export default SharedClassBadge;